import React from 'react'
import { Container } from 'react-bootstrap';
import Slider from "react-slick";
import banner1 from '../images/kvh-banner-1.jpg'
import banner2 from '../images/kvh-banner-2.jpg'
import banner3 from '../images/kvh-banner-3.jpg'
import banner4 from '../images/kvh-banner-4.jpg'
import banner5 from '../images/kvh-banner-5.jpg'
import banner6 from '../images/kvh-banner-6.jpg'
import mbaneer1 from '../images/mb-1.jpg'
import mbaneer2 from '../images/mb-2.jpg'
import mbaneer3 from '../images/mb-3.jpg'
import mbaneer4 from '../images/mb-4.jpg'
import mbaneer5 from '../images/mb-5.jpg'
import mbaneer6 from '../images/mb-6.jpg'
import { isMobile } from 'react-device-detect';

export default function KvhSlider() {
    var settings = {
        dots: true,
        fade: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1500,
        autoplaySpeed: 3500,

    };
    return (


        <div className='overflow-hidden'>
            <Slider {...settings}>
                <div>
                    <img className='img-fluid' src={isMobile ? mbaneer1 : banner1} alt='Krishna Velvet & Handloom' />
                </div>
                <div>
                    <img className='img-fluid' src={isMobile ? mbaneer2 : banner2} alt='Krishna Velvet & Handloom' />
                </div>
                <div>
                    <img className='img-fluid' src={isMobile ? mbaneer3 : banner3} alt='Krishna Velvet & Handloom' />
                </div>
                <div>
                    <img className='img-fluid' src={isMobile ? mbaneer4 : banner4} alt='Krishna Velvet & Handloom' />
                </div>
                <div>
                    <img className='img-fluid' src={isMobile ? mbaneer5 : banner5} alt='Krishna Velvet & Handloom' />
                </div>
                <div>
                    <img className='img-fluid' src={isMobile ? mbaneer6 : banner6} alt='Krishna Velvet & Handloom' />
                </div>

            </Slider>
        </div>


    )
}
